import Table from 'react-bootstrap/Table';
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { FaPencil } from "react-icons/fa6";
import MyComponent from './myComponent';

// Functional component definition
function Instruction() {

  // Inline styles for the table
  const tableStyle = {
    fontSize: '0.9rem',
    width: '100%',
    margin: '0 auto',
    borderCollapse: 'collapse'
  };

  // State to control form visibility (currently unused)
  const [, setIsFormVisible] = useState(false);

  // Handler for save button click
  const handleSaveClick = () => {
    setIsFormVisible(false);
    alert('Provider details saved successfully!');
  };

  return (
    <div>
      {/* Heading */}
      <h3 style={{
        backgroundColor: "white",
        color: "#004aad",
        padding: "5px",
        marginBottom: "5px"
      }}>
        Instructions
      </h3>

      {/* Data table */}
      <Table striped bordered hover style={tableStyle}>
        <tbody>
          <tr>
            <th style={{
              fontSize: '0.9rem',
              borderTop: "3px solid #004aad",
              padding: "5px",
              width: "100%"
            }}>
              {/* Search bar and external component */}
              <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ marginRight: '10px', fontWeight: 'normal' }}>Search:</span>
                <input
                  type="text"
                  placeholder=""
                  style={{ padding: '5px', borderRadius: '4px', height: "35px" }}
                />
                <MyComponent />
              </div>

              {/* Info and header row */}
              <div style={{ marginTop: "5px", fontSize: "15px", fontWeight: "normal" }}>
                Showing 0 to 0 of 0 entries
              </div>
              <br />
              <div style={{ marginTop: "5px", fontWeight: "bold", fontSize: "16px" }}>
                <span style={{ marginRight: "120px" }}>Active</span>
                <span style={{ marginRight: "120px" }}>Function</span>
                <span style={{ marginRight: "120px" }}>Where</span>
                <span>Conditions</span>
              </div>
            </th>
          </tr>

          {/* Message row for empty data */}
          <tr>
            <th style={{ textAlign: "center", fontSize: "16px" }}>
              No data available in table
            </th>
          </tr>

          {/* Footer info row */}
          <tr>
            <th style={{
              borderTop: "3px solid #004aad",
              backgroundColor: "#f4f4f4",
              padding: "15px",
              fontSize: "14px",
              fontWeight: "normal"
            }}>
              Showing 0 to 0 of 0 entries
            </th>
          </tr>
        </tbody>
      </Table>

      {/* Save button */}
      <Button
        style={{
          backgroundColor: '#004aad',
          borderColor: '#004aad',
          marginLeft: '5px',
          marginTop: "50px"
        }}
        onClick={handleSaveClick}
      >
        <FaPencil style={{ marginRight: '5px' }} />
        Save
      </Button>
    </div>
  );
}

export default Instruction;
